import { createReducer, on } from '@ngrx/store';

import { RestInspectionTemplateServiceTaskOptionsModel } from '../../shared/template-editor-dialog/interfaces/inspection-template-service-task-options.interface';
import {
  createTemplateServiceTaskOption,
  createTemplateServiceTaskOptionFailed,
  createTemplateServiceTaskOptionSuccess,
  deleteTemplateServiceTaskOption,
  deleteTemplateServiceTaskOptionFailed,
  deleteTemplateServiceTaskOptionSuccess,
  loadTemplateServiceTaskOptions,
  loadTemplateServiceTaskOptionsFailed,
  loadTemplateServiceTaskOptionsSuccess,
  updateTemplateServiceTaskOption,
  updateTemplateServiceTaskOptionFailed,
  updateTemplateServiceTaskOptionSuccess,
} from '../actions/inspection-template-service-task-options.actions';

export const inspectionTemplateServiceTaskOptionsFeatureKey = 'inspectionTemplateServiceTaskOptions';

export interface InspectionTemplateServiceTaskOptionsState {
  options: RestInspectionTemplateServiceTaskOptionsModel[];
  loading: boolean;
  error: any;
}

export const initialState: InspectionTemplateServiceTaskOptionsState = {
  options: [],
  loading: false,
  error: null,
};

export const inspectionTemplateServiceTaskOptionsReducer = createReducer(
  initialState,
  on(loadTemplateServiceTaskOptions, state => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(loadTemplateServiceTaskOptionsSuccess, (state, { options }) => ({
    ...state,
    options,
    loading: false,
    error: null,
  })),
  on(loadTemplateServiceTaskOptionsFailed, (state, action) => ({
    ...state,
    loading: false,
    error: action,
  })),
  on(createTemplateServiceTaskOption, state => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(createTemplateServiceTaskOptionSuccess, (state, { option }) => ({
    ...state,
    options: [...state.options, option],
    loading: false,
    error: null,
  })),
  on(createTemplateServiceTaskOptionFailed, (state, action) => ({
    ...state,
    loading: false,
    error: action,
  })),
  on(updateTemplateServiceTaskOption, state => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(updateTemplateServiceTaskOptionSuccess, (state, { option }) => ({
    ...state,
    options: state.options.map(o => (o.id === option.id ? option : o)),
    loading: false,
    error: null,
  })),
  on(updateTemplateServiceTaskOptionFailed, (state, action) => ({
    ...state,
    loading: false,
    error: action,
  })),
  on(deleteTemplateServiceTaskOption, state => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(deleteTemplateServiceTaskOptionSuccess, (state, { optionId }) => ({
    ...state,
    options: state.options.filter(o => o.id !== optionId),
    loading: false,
    error: null,
  })),
  on(deleteTemplateServiceTaskOptionFailed, (state, action) => ({
    ...state,
    loading: false,
    error: action,
  }))
);
